/**
 * Chart.js on demand.
 *
 * Chart.js is ~200 KB of controllers, and it used to sit in the module graph of
 * every surface that can draw a value history: `DeviceWidget` pulls
 * `SensorWidget`/`GenericWidget`, both of which draw a sparkline, so opening any
 * page that grids device tiles downloaded and parsed all of it up front — even
 * though the sparkline only exists inside the control sheet.
 *
 * The import therefore lives here, behind a promise, and every caller gets the
 * same module instance (so `Chart.register` runs once).
 */
type ChartModule = typeof import('chart.js');

let chartModule: ChartModule | null = null;
let chartModulePromise: Promise<ChartModule> | null = null;

export function loadChartJs(): Promise<ChartModule> {
  if (chartModule) return Promise.resolve(chartModule);

  chartModulePromise ??= import('chart.js').then((mod) => {
    mod.Chart.register(...mod.registerables);
    chartModule = mod;
    return mod;
  });

  return chartModulePromise;
}
